module.exports = __webpack_public_path__ + "media/images/favicon/secondary/apple-icon-57x57-cc8d1dc477a6dff764b3e860a7777859.png";